(function () {
  'use strict';

  var id = 'line-chart';
  var lineChartMeasures = null;

  // Add onto the wsLrs.cards module...
  angular.module('wsLrs.cards').config(['$routeProvider', function ($routeProvider) {
    // Add routes
    $routeProvider.when('/line/:cardId', {
      templateUrl: 'modules/app/line-chart/line-chart-detail.html',
      controller: id + ".Detail",
      resolve: {
        cardLoader: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    }).when('/line/:cardId/top', {
      templateUrl: 'modules/app/line-chart/line-chart-card.html',
      resolve: {
        cardLoader: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    });
  }]).run(['CardIconMap', function (CardIconMap) {
    CardIconMap.register({
      "line": "line"
    });
  }]).controller(id + ".CardConfiguration", ["$scope", "$controller", 'Dimensions', 'ExplorerService', 'Utils', function ($scope, $controller, Dimensions, ExplorerService, Utils) {
    var isUndefined = Utils.isUndefined,
      find = Utils.find,
      reduce = Utils.reduce,
      debounce = Utils.debounce;
    $scope.tempMeasures = lineChartMeasures;
    $scope.templateType = "line";
    $controller("AggregationCardConfiguration", {
      $scope: $scope
    });
    $scope.lineChartHelpText = {
      helpTitle: 'Line',
      detailText: "In the Line section, you'll choose how you want to group data (in the Organized menu) " + "and what measures you'll want to see (using the Measures menu). Choose an option in the Organized " + "menu first, and then select as many measures as you'd like by choosing them in the dropdown and " + "clicking Add Measure. <a target='_blank' href='https://watershedlrs.zendesk.com/hc/en-us/articles/115003488746-Setting-up-and-Configuring-a-Line-Card'>Learn more</a>."
    };
    var cardToEdit = ExplorerService.getCard() || {};
    if (isUndefined(cardToEdit.configuration.line)) {
      cardToEdit.configuration.line = true;
      $scope.workingConfig.line = true;
    }

    // If a dimension other than TIME has been configured, add it to the list of dimensions
    var customDimension = $scope.config.dimensions && $scope.config.dimensions.find(function (d) {
      return d.type !== 'TIME';
    });
    //We force a dimension of time, allow the user to select day, week, month, year
    $scope.timeDimensions = Dimensions.getTimeDimensions(customDimension);

    //it is possible to select another non-time dimension; if they do each line on the chart is another dimension
    $scope.nonTimeDimensions = Dimensions.getNonTimeDimensions($scope.peoplePickerConfig.hasGroups);
    if (isUndefined(cardToEdit.configuration.dimensions)) {
      //we set this here to prevent the aggregation card config from setting it later
      $scope.timeDimension = $scope.timeDimensions[0];
      $scope.workingConfig.dimensions = [$scope.timeDimension];
      cardToEdit.configuration.dimensions = [$scope.timeDimension];
    } else {
      var dim = cardToEdit.configuration.dimensions[0];
      //if the chosen dimension is not time based, choose a better default
      if (!find($scope.timeDimensions, function (d) {
        return angular.equals(d.val, dim);
      })) {
        $scope.timeDimension = $scope.timeDimensions[0];
        cardToEdit.configuration.dimensions[0] = $scope.timeDimension;
        $scope.workingConfig.dimensions[0] = $scope.timeDimension;
      } else {
        $scope.timeDimension = dim.type === 'TIME' ? {
          name: "By " + dim.timePeriod.toLowerCase(),
          val: dim
        } : {
          name: "Custom",
          val: dim
        };
      }
      if (cardToEdit.configuration.dimensions.length > 1) {
        var optDim = cardToEdit.configuration.dimensions[1];
        if (optDim.statementProperty) {
          $scope.optionalDimension = find($scope.nonTimeDimensions, function (d) {
            return d.val.statementProperty === optDim.statementProperty;
          });
          if (!$scope.optionalDimension) {
            //if we don't find it take our best guess at it
            $scope.optionalDimension = {
              name: "By " + reduce(optDim.statementProperty.split("."), function (memo, x) {
                return memo + " " + x;
              }).trim(),
              val: optDim
            };
          }
        } else {
          $scope.optionalDimension = {
            name: "By " + dim.timePeriod.toLowerCase(),
            val: optDim
          };
        }
      }
    }
    $scope.$watch("timeDimension", debounce(function (item) {
      if (!item) {
        return;
      }
      $scope.workingConfig.dimensions[0] = item.val;
      $scope.updateCardWithWorkingConfig();
    }, 100), true);
    var applyOptionalDimensionToWorkingConfig = debounce(function (item) {
      if (!item) {
        if ($scope.workingConfig.dimensions.length > 1) {
          $scope.workingConfig.dimensions = [$scope.workingConfig.dimensions[0]];
          $scope.updateCardWithWorkingConfig();
        }
        return;
      }
      if ($scope.workingConfig.dimensions.length < 2) {
        $scope.workingConfig.dimensions.push({});
      }
      $scope.workingConfig.dimensions[1] = item.val;
      $scope.updateCardWithWorkingConfig();
    }, 100);
    $scope.$watch("optionalDimension", applyOptionalDimensionToWorkingConfig, true);
    $scope.onStatementPropertyChanged = applyOptionalDimensionToWorkingConfig;
    $scope.$watch("workingConfig.line", debounce(function () {
      $scope.updateCardWithWorkingConfig();
    }, 100), true);
    $scope.$watch("workingConfig.singleGraph", debounce(function () {
      $scope.updateCardWithWorkingConfig();
    }, 100), true);
    $scope.$watch("workingConfig.allowGaps", debounce(function () {
      $scope.updateCardWithWorkingConfig();
    }, 100), true);
    $scope.$watch("workingConfig.fillGapsWithZeroes", debounce(function () {
      $scope.updateCardWithWorkingConfig();
    }, 100), true);
    $scope.$watch("workingConfig.cumulativeSum", debounce(function () {
      $scope.updateCardWithWorkingConfig();
    }, 100), true);
  }]).controller(id + ".Card", ["$scope", "CardRegistry", id + '.Utils', 'AggregationUtils', 'wsEventNames', '$routeParams', 'ReportValidationService', 'Utils', function ($scope, CardRegistry, Utils, AggUtils, wsEvents, $routeParams, ReportValidationService, AppUtils) {
    var isEmpty = AppUtils.isEmpty;
    var contains = AppUtils.contains;
    var filter = AppUtils.filter;

    // For use with /top route when embedding
    if (!$scope.cardId && $routeParams.cardId) {
      $scope.cardId = $routeParams.cardId;
    }
    $scope.config = CardRegistry.get($scope.cardId).configuration;

    // We don't want to sort line chart data, if time based
    if (Utils.isTimeBasedDimension($scope.config)) {
      $scope.config.defaultSort = undefined;
    }
    if (!$scope.config.hiddenMeasures) {
      $scope.config.hiddenMeasures = [];
    }
    var validation = ReportValidationService.validate($scope.cardId);
    if (validation.hasErrors) {
      $scope.hasData = false;
      $scope.noDataMsg = validation.message;
      return;
    }
    if ($scope.config && $scope.config.dimensions && $scope.config.dimensions[0]) {
      $scope.defaultSummary = 'Line chart of measures organized by ' + AggUtils.getDimensionInSentence($scope.config.dimensions[0], true);
    }
    var fetchCfg = {
      cardId: $scope.cardId,
      cardToPreview: $scope.cardToPreview,
      cardConfig: $scope.config,
      params: {
        "order_by": $scope.config.defaultSort
      }
    };
    if ($scope.config.dimensions.length > 1) {
      fetchCfg.params = {
        "_limit": 1
      };
      Utils.fetchDimensions(fetchCfg).then(function (r) {
        $scope.dimensionsOnChart = isEmpty($scope.config.defaultSecondDimensions) ? [r.results[0].result.data[0].values[0].value] : $scope.config.defaultSecondDimensions;
        fetchCfg.params = {
          "dimensionIds": $scope.dimensionsOnChart
        };
        Utils.fetchData(fetchCfg).then(function (r) {
          // Advertise that the preview loaded, with the preview data
          if ($scope.cardToPreview) {
            $scope.$emit(wsEvents.card.preview.loaded, r);
          }
          $scope.data = r[0].results[0].result.data;
          var eventLines = r[1];
          if (!Utils.ensureDataSize($scope, $scope.data)) {
            return;
          }
          $scope.data = filter($scope.data, function (d) {
            return d.values.length > 1 && contains($scope.dimensionsOnChart, d.values[1].value);
          });
          var stats = r[0].results[0].result.stats;
          $scope.lineChart = Utils.getLineChart($scope.data, $scope.config, stats, undefined, eventLines);
          $scope.hasData = $scope.data.length > 0;
        }, function () {
          $scope.hasData = false;
        });
      });
    } else {
      Utils.fetchData(fetchCfg).then(function (r) {
        $scope.data = r[0].results[0].result.data;
        var eventLines = r[1];
        if (!Utils.ensureDataSize($scope, $scope.data)) {
          return;
        }
        var stats = r[0].results[0].result.stats;
        $scope.lineChart = Utils.getLineChart($scope.data, $scope.config, stats, undefined, eventLines);
        $scope.hasData = $scope.data.length > 0;
      }, function () {
        $scope.hasData = false;
      });
    }
  }]).controller(id + ".Detail", ["$scope", "$routeParams", id + ".Utils", "CardRegistry", 'ReportValidationService', "$timeout", "wsEventNames", 'Api', 'CardUtils', "CardQueryResource", 'AggregationUtils', '$filter', 'Utils', function ($scope, $routeParams, Utils, CardRegistry, ReportValidationService, $timeout, wsEventNames, Api, CardUtils, CardQueryResource, AggUtils, $filter, AppUtils) {
    var forEach = AppUtils.forEach;
    var isEmpty = AppUtils.isEmpty;
    var contains = AppUtils.contains;
    var chain = AppUtils.chain;
    var filter = AppUtils.filter;
    var findIndex = AppUtils.findIndex;
    $scope.cardId = $routeParams.cardId;
    $scope.card = CardRegistry.get($scope.cardId);
    $scope.config = $scope.card.configuration;

    // We don't want to sort line chart data, if time based
    if (Utils.isTimeBasedDimension($scope.config)) {
      $scope.config.defaultSort = undefined;
    }
    if (!$scope.config.hiddenMeasures) {
      $scope.config.hiddenMeasures = [];
    }
    var validation = ReportValidationService.validate($scope.cardId);
    if (validation.hasErrors) {
      $scope.hasData = false;
      $scope.noDataMsg = validation.message;
      return;
    }
    $scope.checkedBox = function checkedBox(d) {
      if ($scope.dataOnChart.indexOf(d) > -1) {
        $scope.removeFromChart(d);
      } else {
        $scope.addToChart(d);
      }
    };
    $scope.addToChart = function addToChart(d) {
      $scope.dataOnChart.push(d);
    };
    $scope.removeFromChart = function removeFromChart(d) {
      var i = $scope.dataOnChart.indexOf(d);
      if (i > -1) {
        $scope.dataOnChart.splice(i, 1);
      }
    };
    $scope.isOnChart = function isOnChart(d) {
      return $scope.dataOnChart.indexOf(d) >= 0;
    };

    //data to place on the line chart
    $scope.dataOnChart = [];
    $scope.$watchCollection('dataOnChart', function () {
      if (isEmpty($scope.dataOnChart)) {
        return;
      }
      $scope.loadingDimensionData = true;
      var fetchCfg = {
        cardId: $scope.cardId,
        cardToPreview: $scope.cardId === 'preview' ? $scope.card : null,
        cardConfig: $scope.config,
        params: {
          "dimensionIds": $scope.dataOnChart
        }
      };
      Utils.fetchData(fetchCfg).then(function (r) {
        $scope.data = r[0].results[0].result.data;
        var eventLines = r[1];
        if (!Utils.ensureDataSize($scope, $scope.data)) {
          return;
        }
        $scope.data = filter($scope.data, function (d) {
          return d.values.length > 1 && contains($scope.dataOnChart, d.values[1].value);
        });
        var stats = r[0].results[0].result.stats;
        if ($scope.config.singleGraph) {
          $scope.lineCharts = [Utils.getLineChart($scope.data, $scope.config, stats, undefined, eventLines)];
        } else {
          $scope.lineCharts = $scope.config.measures
          // Filter down to measures we're displaying
          .filter(function (m, i) {
            return $scope.config.hiddenMeasures.indexOf(i) === -1;
          })
          // Just grab the indices for those displayed measures       // try ids first              // use names otherwise
          .map(function (m) {
            return findIndex($scope.config.measures, function (compareM) {
              return m.id && m.id === compareM.id || m.name && m.name === compareM.name;
            });
          })
          // Pass the indices to the getLineChart function
          .map(function (index) {
            return Utils.getLineChart($scope.data, $scope.config, stats, index, eventLines);
          });
        }
        $scope.loadingDimensionData = false;
      });
    });
    var dimensionLabels = AggUtils.getDimensionLabels({
      config: $scope.config,
      context: 'detailView'
    });
    $scope.sortControls = [{
      "title": $filter('capitalize')(dimensionLabels[1])
    }, {
      "title": "Add to chart"
    }];
    $scope.fetchData = function (cfg) {
      var offset = cfg._offset || 0;
      var limit = cfg._limit || 10;
      var fetchCfg = {
        cardId: $scope.cardId,
        cardToPreview: $scope.cardId === 'preview' ? $scope.card : null,
        cardConfig: $scope.config,
        params: {
          "_limit": limit,
          "_offset": offset,
          "order_by": $scope.sortDirective
        }
      };
      return Utils.fetchDimensions(fetchCfg).then(function (data) {
        $scope.data = data.results[0].result.data;
        if (!Utils.ensureDataSize($scope, $scope.data)) {
          return;
        }
        $scope.hasData = $scope.data.length > 0;
        $scope.pagenote.setReportMetadata(data);
        if (isEmpty($scope.dataOnChart)) {
          if (!isEmpty($scope.config.defaultSecondDimensions)) {
            $scope.dataOnChart = $scope.dataOnChart.concat($scope.config.defaultSecondDimensions);
          } else {
            $scope.addToChart($scope.data[0].values[0].value);
          }
        }
        forEach($scope.data, function (d) {
          return d.displayName = AggUtils.getDimensionDisplay(d.values[0], $scope.config.dimensions[1]);
        });
        return {
          count: data.results[0].result.count,
          results: $scope.data
        };
      }, function () {
        $scope.hasData = false;
      });
    };
    CardUtils.setNavElements($scope, $scope.cardId, $scope.cardId);
    $scope.subDetails = [{
      text: "Download data",
      downloadData: true,
      tooltip: "Download data tables",
      href: CardQueryResource.getDownloadUrl('line-chart/csv', $scope.cardId, $scope.config)
    }, {
      text: "Download interaction statements",
      downloadData: true,
      tooltip: "Download interaction statements",
      callback: Utils.getStatementDownloadUrl($scope.cardId === 'preview' ? $scope.config : $scope.cardId)
    }];
    $scope.pagenote = {
      "clearCacheAction": "cards/" + $scope.cardId + "/cache"
    };
    $scope.sortDirective = "dimension[0].label";
    if ($scope.config.dimensions.length < 2) {
      var fetchCfg = {
        cardId: $scope.cardId,
        cardToPreview: $scope.cardId === 'preview' ? $scope.card : null,
        cardConfig: $scope.config,
        params: {
          "order_by": $scope.config.defaultSort
        }
      };
      Utils.fetchData(fetchCfg).then(function (r) {
        $scope.data = r[0].results[0].result.data;
        var eventLines = r[1];
        if (!Utils.ensureDataSize($scope, $scope.data)) {
          return;
        }
        $scope.pagenote.setReportMetadata(r[0]);
        var stats = r[0].results[0].result.stats;

        // Sad, but due to a very odd timing issue, this has to be in
        // a very slightly delayed $timeout call
        $timeout(function () {
          if (!$scope.config.singleGraph) {
            $scope.lineCharts = chain($scope.config.measures).filter(function (m, i) {
              return $scope.config.hiddenMeasures.indexOf(i) === -1;
            }).map(function (m, mi) {
              return Utils.getLineChart($scope.data, $scope.config, stats, mi, eventLines);
            }).value();
          } else {
            $scope.lineCharts = [Utils.getLineChart($scope.data, $scope.config, stats, undefined, eventLines)];
          }
        }, 10);
        $scope.hasData = $scope.data.length > 0;
      }, function () {
        $scope.hasData = false;
      });
    } else {
      $timeout(function () {
        $scope.$broadcast(wsEventNames.pager.setPage, 1);
      }, 0);
    }
  }]);
})();
